import { mergeAll } from "../../lib/base/actions";
let currentUid = 0;
const getNextUid = () => currentUid++;
export default class Mixin {
    options;
    name;
    store;
    actions;
    controllers;
    selectors;
    ids = {};
    constructor(store, name = "mapsightMixin-" + getNextUid(), options = {}) {
        this.store = store;
        this.name = name;
        this.options = options;
        this.controllers = Object.assign({}, this.getDefaultControllerNames(), this.options.controllers || {});
        this.beforeInitialization();
        this.actions = this.bindActions();
        this.selectors = this.bindSelectors();
        this.store.dispatch(mergeAll(this.getInitialState()));
        this.afterInitialization();
    }
    createId(id) {
        return `${this.name}_${id}`;
    }
    beforeInitialization() {
        //
    }
    afterInitialization() {
        //
    }
    getInitialState() {
        return {};
    }
    getDefaultControllerNames() {
        return {};
    }
    bindActions() {
        return {};
    }
    bindSelectors() {
        return {};
    }
}
